export function addToCompare(
    event: React.MouseEvent<HTMLElement>,
    product: any,
    setCompareArray: (values: any[]) => void,
    compareArray: any[]
) {
    event.preventDefault();
    event.stopPropagation();

    const isAlreadyPresent = (currentValue: any) =>
        currentValue.product.code !== product.code;
    const canCompare = compareArray.every(isAlreadyPresent);

    if (compareArray.length < 3 && canCompare) {
        setCompareArray([
            ...compareArray,
            { pos: compareArray.length, product: product },
        ]);
    }
}
